<!--<h2 mat-dialog-title>Select Date Range</h2>-->
<mat-dialog-content class="date-dialog-content">
  <mat-form-field appearance="fill">
    <mat-label>Zeitraum</mat-label>

    <mat-date-range-input [rangePicker]="picker" [max]="today">
      <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
      <input matEndDate placeholder="End date" [(ngModel)]="endDate">
    </mat-date-range-input>

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>

  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="apply()" [disabled]="!startDate || !endDate">
    Anwenden
  </button>
</mat-dialog-actions>
